import theme from '@app/ui/theme'
import styled from 'styled-components'

export const TreesImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
